import { TreeHelper } from 'choerodon-ui/dataset';
const treeReduce = TreeHelper.treeReduce;
const treeForEach = TreeHelper.treeForEach;
const treeFind = TreeHelper.treeFind;
const treeSome = TreeHelper.treeSome;
const treeMap = TreeHelper.treeMap;
export { treeReduce, treeForEach, treeFind, treeSome, treeMap, };
